import { Outlet } from 'react-router-dom'

export function OperationsFrame() {
  return (
    <div className="mx-auto min-h-full max-w-7xl">
      <Outlet />
    </div>
  )
}
